import { gql } from '@apollo/client/core'
import { Notify } from 'quasar'
import { isElectronMode } from 'src/config'

/**
 * @param {import('@quasar/app-webpack').BootFileParams} params
 */
export default async ({ app }) => {
  const remoteCommands = {
    observationResponse: null
  }

  remoteCommands.unsubscribe = () => {
    if (!_.isNil(remoteCommands.observationResponse)) {
      remoteCommands.observationResponse.unsubscribe()
    }
  }

  remoteCommands.subscribe = () => {
    if (!app.config.globalProperties.$cable) return

    remoteCommands.unsubscribe()

    const subQuery = gql`subscription {
      remoteCommandSent {
        remoteCommand {
          command
          data
        }
      }
    }`

    const PAYMENT_CONNECTOR_REST_REQUEST = 'payment-connector-rest-request'
    const PAYMENT_CONNECTOR_UPDATED = 'payment-connector-updated'
    const PAYMENT_CONNECTOR_MESSAGE = 'payment-connector-message'
    const PREPARATION_ORDER_UPDATED = 'preparation_order_updated'
    const MODEL_UPDATED = 'model_updated'
    const UPDATE_ENVIRONMENT_STATUS = 'update-environment-status'
    const PRINT_RECEIPT = 'print-receipt'
    const CARD_READ = 'card-read'
    const UPC_READ = 'upc-read'
    const REQUEST_SCREEN_DATA = 'request-screen-data'
    const DISPLAY_MESSAGE = 'display-message'

    const observer = app.apolloProvider.defaultClient.subscribe({
      query: subQuery
    })

    remoteCommands.observationResponse = observer.subscribe({
      next (data) {
        console.log(data)
        if (_.isNil(data?.data?.remoteCommandSent?.remoteCommand)) return

        const command = data.data.remoteCommandSent.remoteCommand.command
        const commandData = JSON.parse(data.data.remoteCommandSent.remoteCommand.data)

        remoteCommands.remoteCommandReceived && remoteCommands.remoteCommandReceived(command)

        if (command === CARD_READ && remoteCommands.handleCardData) {
          if (app.config.globalProperties.$customerDisplayHandler?.isRegister === false) return

          remoteCommands.handleCardData(commandData.uid)
        } else if (command === REQUEST_SCREEN_DATA) {
          remoteCommands.handleRequestScreenData && remoteCommands.handleRequestScreenData()
        } else if (command === 'request-console-stream') {
          remoteCommands.handleRequestConsoleStream && remoteCommands.handleRequestConsoleStream()
        } else if (command === UPC_READ && remoteCommands.handleUpcScanned) {
          if (app.config.globalProperties.$customerDisplayHandler?.isRegister === false) return

          remoteCommands.handleUpcScanned(commandData.uid)
        } else if (command === PRINT_RECEIPT) {
          if (app.config.globalProperties.$customerDisplayHandler?.isRegister === false) return

          if (!isElectronMode) {
            Notify.create({
              message: 'Unable to print, app not running in electron mode',
              type: 'negative',
              position: 'top'
            })
          } else {
            const printResult = remoteCommands.handlePrintData(commandData)
            console.log(printResult)
            if (printResult.error) {
              Notify.create({
                message: printResult.message,
                type: 'negative',
                position: 'top'
              })
            }
          }
        } else if (command === PAYMENT_CONNECTOR_UPDATED && remoteCommands.handlePaymentUpdate) {
          if (app.config.globalProperties.$customerDisplayHandler?.isRegister === false) return

          remoteCommands.handlePaymentUpdate(commandData)
        } else if (command === PAYMENT_CONNECTOR_MESSAGE) {
          if (app.config.globalProperties.$customerDisplayHandler?.isRegister === false) return

          Notify.create({
            message: commandData.message,
            type: 'info',
            position: 'top'
          })
        } else if (command === PAYMENT_CONNECTOR_REST_REQUEST) {
          if (app.config.globalProperties.$customerDisplayHandler?.isRegister === false) return

          remoteCommands.handlePaymentRestRequest && remoteCommands.handlePaymentRestRequest(commandData)
        } else if (command === PREPARATION_ORDER_UPDATED && remoteCommands.handleUpdatedKdsData) {
          remoteCommands.handleUpdatedKdsData(commandData.order_id)
        } else if (command === MODEL_UPDATED) {
          if (remoteCommands.handleModelUpdated) {
            remoteCommands.handleModelUpdated(commandData.model_name)
          } else if (commandData.message) {
            Notify.create({
              message: commandData.message,
              type: 'info',
              position: 'top'
            })
          }
        } else if (command === UPDATE_ENVIRONMENT_STATUS) {
          // Do nothing
        } else if (command === DISPLAY_MESSAGE) {
          Notify.create({
            message: commandData.message,
            type: 'info',
            position: 'top'
          })
        } else {
          Notify.create({
            message: command + ' ' + data.data.remoteCommandSent.remoteCommand.data,
            type: 'info',
            position: 'top'
          })
        }
      },
      error (error) {
        console.error(error)
      }
    })
  }

  app.config.globalProperties.$remoteCommands = remoteCommands
  app.$remoteCommands = remoteCommands
  window.$remoteCommands = remoteCommands
}
